import { h, Component, Host, Element } from '@stencil/core';

import type { TableStateInterface } from '../../../../services/interfaces';
import { getTableState } from '../helpers/table-state';

@Component({
  tag: 'pk-table-header',
  styleUrl: './scss/pk-table-header.scss',
  scoped: true,
})
export class PkTableHeader {
  // Own Properties
  // ====================

  private tableState: TableStateInterface;

  // Reference to host HTML element
  // ===================================
  @Element() el: HTMLPkTableHeaderElement;

  // State() variables
  // Inlined decorator, alphabetical order
  // =======================================

  // Public Property API
  // ========================

  // Prop lifecycle events
  // =======================

  // Events section
  // Requires JSDocs for public API documentation
  // ==============================================

  // Component lifecycle events
  // Ordered by their natural call order
  // =====================================

  // Listeners
  // ==============

  // Public methods API
  // These methods are exposed on the host element.
  // Always use two lines.
  // Public Methods must be async.
  // Requires JSDocs for public API documentation.
  // ===============================================

  // Local methods
  // Internal business logic.
  // ==========================
  componentWillLoad() {
    const tableId = this.el.closest<HTMLPkTableElement>('pk-table[table-id]')?.tableId;
    this.tableState = getTableState(tableId);
  }

  // 1render() function
  // Always the last one in the class.
  // ===================================

  render() {
    if (!this.tableState) return null;

    const { useFixedWidth, noHeader, firstCellMobileHeader } = this.tableState;
    return (
      <Host
        class={{
          'pk-table--header': true,
          'is-hidden': noHeader,
          'fixed-width': useFixedWidth,
          mobile: firstCellMobileHeader,
        }}
        role="rowgroup"
      >
        <slot />
      </Host>
    );
  }
}
